// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-DownloadSuccess----index-module---root---2fG5U","title":"src-components-DownloadSuccess----index-module---title---2t3Yz","body":"src-components-DownloadSuccess----index-module---body---25okk","button":"src-components-DownloadSuccess----index-module---button---2pslK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadSuccess/index.module.css
// module id = 604
// module chunks = 114276838955818